// import {extent as d3_extent} from 'd3-array'
import { select as d3_select } from 'd3-selection'
import drawGradientRect from '../utils/drawGradientRect'

function TrendLegendBehavior($root, data, config = {}) {
  if (!data) return
  let drawLegend = function (legend, legendData) {
    let items = legend.selectAll('.legend-item').data(legendData, d => d.id)
    let itemsEnter = items
      .enter()
      .append('div')
      .attr('class', 'legend-item')
      .style('display', 'flex')
      .style('align-items', 'center')
      .style('margin', '5px')

    items.exit().style('opacity', 0).remove()

    itemsEnter.append('div').attr('class', 'icon').style('width', '10px').style('height', '10px')

    itemsEnter.append('div').attr('class', 'label')

    /*
    itemsEnter.on('click', (e, d) => {
      chart && chart.emit('labelClick', d)
    })
    */

    items = items.merge(itemsEnter)

    items
      .select('.label')
      .text(d => d.label)
      .style('font-size', '14px')
    items
      .select('.icon')
      .style('margin', '6px 8px 4px 4px') //BASURA ESTE 6px, (es porque la fuente no esta "bien centrada" creo)
      .transition()
      .style('background', dd => dd.color)

    let icon = legendData.icon || config.icon
    if (icon === 'circle') {
      items
        .select('.icon')
        .classed('circle', true)
        .style('width', '10px')
        .style('height', '10px')
        .style('border-radius', '10px')
    } else if (icon === 'line') {
      items.select('.icon').classed('rect', true).style('width', '10px').style('height', '2px')
    } else {
      items
        .select('.icon')
        .classed('dented-rect', true)
        .style('width', '10px')
        .style('height', '10px')
        .style('border-radius', '3px 0 3px 0')
    }
  }

  let reducedData = Object.keys(data)
    .map(key => ({ id: key, ...data[key] }))
    .filter(item => item.id !== 'index')

  let legends = d3_select($root).selectAll('.trend-legend').data([data])
  legends.exit().remove()
  let legendsEnter = legends.enter().append('div').attr('class', 'trend-legend')
  legendsEnter.style('opacity', 0).transition().duration(1000).style('opacity', 1)
  legends = legends.merge(legendsEnter)
  legends
    .style('display', 'flex')
    .style('flex-wrap', 'wrap')
    .style('align-items', 'center')
    .style('margin-top', '5px')

  legends.each(function (d) {
    drawLegend(d3_select(this), reducedData)
  })
}

TrendLegendBehavior.defaultConfig = {
  index: 201,
  /**
   * {-EN-} Show or hide the legend of the trendlines.
   * {-ES-} Muestra u oculta la leyenda de las líneas de tendencia.
   */
  showLegend: {
    type: Boolean,
    default: false,
    exposed: true,
  },
  icon: {
    type: [String],
    options: ['square', 'circle', 'line'],
    default: 'line',
  },
}
TrendLegendBehavior.configName = 'TrendLegendBehavior'

export default TrendLegendBehavior
